module.exports = __webpack_public_path__ + "media/images/flags/1x1/bfa-ab77397ef9cccbb890237d757687aabf.svg";